import script from "./video.vue?vue&type=script&setup=true&lang=js"
export * from "./video.vue?vue&type=script&setup=true&lang=js"

import "./video.vue?vue&type=style&index=0&id=5aca46fd&lang=scss&scoped=true"

import exportComponent from "D:\\六问前端\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5aca46fd"]])

export default __exports__